import template from './secureFileUploaderUploadStage.html';
import controller from './secureFileUploaderUploadStage.controller';

let secureFileUploaderUploadStageComponent = {
  restrict: 'E',
  bindings: {
    uploadState: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default secureFileUploaderUploadStageComponent;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderUploadStage/secureFileUploaderUploadStage.component.js